export const addClient = async (clientData) => {
    const token = localStorage.getItem('token'); // Get token from localStorage
    const apiUrl = process.env.REACT_APP_API_URL;
    const response = await fetch(`${apiUrl}/api/facture_client`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`, // Attach the token here
        },
        body: JSON.stringify(clientData),
    });

    if (!response.ok) {
        throw new Error(`Failed to add client with passport ${clientData.passport}`);
    }

    return await response.json(); // You can return the response data (if needed)
};